import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

import { httpOk, GET, POST, PUT, } from 'helpers/api'
import { formatDate } from "helpers/helpers"
import IntegrationKeyWebhook from "./IntegrationKeyWebhook"

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [externalMenus, setExternalMenus] = useState([])
	const [orderTypeSubs, setOrderTypeSubs] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [webhookItem, setWebhookItem] = useState(null)

	async function searchWithFilter() {
		var filterUrl = "/external-integrations-keys"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function getExternalMenus() {
		const response = await GET('/helper/external-menu')
		if (httpOk(response)) setExternalMenus(response.data)
	}

	async function getOrderTypeSubs() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderTypeSubs(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		if (selectedItem.id) {
			response = await PUT('/external-integrations-keys', selectedItem, { loader: true })
		} else {
			response = await POST('/external-integrations-keys', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalCreateUpdate()
		}
	}

	async function copyToClipboard(uuid) {
		try {
			await navigator.clipboard.writeText(String(uuid || ''))
			toast.success(t('copied'))
		} catch (error) {
			toast.error(t('error'))
		}
	}

	async function toggleModalCreateUpdate(bool = false, item = {}) {
		setSelectedItem(item)
		setModalCreateUpdate(bool)
	}

	useEffect(() => {
		searchWithFilter()
		getExternalMenus()
		getOrderTypeSubs()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('integration_keys')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					{/* Ссылку на документацию отдаём вместе с ключом — интегратору нужно и то, и другое */}
					<a className="btn-rounded btn btn-outline-primary text-nowrap"
						href="https://api.mison.uz" target="_blank" rel="noreferrer">
						<i className="uil uil-book-open me-1"></i>{t('documentation')}
					</a>
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModalCreateUpdate(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px' }} className="text-center">#</th>
									<th>{t('name2')}</th>
									<th>API-KEY</th>
									<th style={{ 'width': '150px' }} className="text-center text-nowrap">{t('valid_until')}</th>
									<th style={{ 'width': '150px' }} className="text-center text-nowrap">{t('date')}</th>
									<th style={{ 'width': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											{/* Название открывает редактирование — так же, как пункт «Изменить» в меню строки */}
											<span className="text-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModalCreateUpdate(true, item)}>
												{item.name}
											</span>
											{/* Вебхук бывает у любого ключа: брони, смены — по правам ключа */}
											{!!item.webhook_url &&
												<div className="small text-muted" title={item.webhook_url}>
													<i className="uil-link-alt"></i> {item.is_webhook_active ? t('webhook') : t('webhook_inactive')}
												</div>
											}
										</td>
										{/* Ключ копируется кликом — интегратору его передают первым делом */}
										<td className="text-nowrap" style={{ 'cursor': 'pointer' }} title={t('copy')}
											onClick={() => copyToClipboard(item.uuid)}>
											{item.uuid} <i className="uil-copy-alt text-muted"></i>
										</td>
										<td className="text-center">
											{item.expires_at ? formatDate(item.expires_at) : '-'}
										</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCreateUpdate(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => setWebhookItem(item)}>
															<i className="uil-link-alt"></i>
															{t('webhook')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL CREATE UPDATE */}
			<Modal show={modalCreateUpdate} animation={false} centered
				onHide={() => toggleModalCreateUpdate()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						{/* Витрина: без неё интегратору видны все внешние меню бренда,
						включая меню агрегаторов с их наценкой. Пустой выбор = основное меню:
						весь каталог через GET /nomenclature по ценам точки */}
						<div className="form-group">
							<label>{t('external_menu')}</label>
							<Select
								isClearable
								options={externalMenus}
								value={externalMenus.find(option => option.id === selectedItem.external_group_id) || ''}
								onChange={(option) => setSelectedItem({
									...selectedItem, 'external_group_id': option ? option.id : null
								})}
								placeholder={t('api_main_menu')}
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
							<div className="small text-muted mt-1">{t('api_main_menu_hint')}</div>
						</div>

						{/* Подтип: по нему заказы интегратора отделяются в отчётах
						от Telegram-бота и колл-центра */}
						<div className="form-group">
							<label>{t('order_type')}</label>
							<Select
								isClearable
								options={orderTypeSubs}
								value={orderTypeSubs.find(option => option.id === selectedItem.order_type_sub_id) || ''}
								onChange={(option) => setSelectedItem({
									...selectedItem, 'order_type_sub_id': option ? option.id : null
								})}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('valid_until')}</label>
							<input type="date" className="form-control" name="expires_at"
								value={selectedItem.expires_at ? selectedItem.expires_at.substring(0, 10) : ''}
								onChange={(e) => setSelectedItem({
									...selectedItem, 'expires_at': e.target.value ? e.target.value : null
								})} />
						</div>

						{/* Выручка, себестоимость и зарплаты через API — только по явной галочке:
						ключи обычно выдаются разработчикам приложений заказов */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_reports_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_reports_allowed"
									checked={selectedItem.is_reports_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_reports_allowed': e.target.checked
									})} />
							</div>
						</div>

						{/* Приход и уход сотрудников из внешней системы (своё приложение, турникет):
						отметки двигают зарплату по часам, поэтому тоже только по явной галочке */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_attendance_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_attendance_allowed"
									checked={selectedItem.is_attendance_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_attendance_allowed': e.target.checked
									})} />
							</div>
						</div>

						{/* Сервис бронирования: видит залы, свободные столы и телефоны своих гостей,
						ставит и отменяет брони — только по явной галочке. События ему — вебхуком (в меню ключа) */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_reservations_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_reservations_allowed"
									checked={selectedItem.is_reservations_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_reservations_allowed': e.target.checked
									})} />
							</div>
						</div>

						{/* Приход товара из своей учётной программы или бота: проводится сразу —
						двигает остаток, себестоимость и долг поставщику, поэтому только по явной галочке */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_receipts_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_receipts_allowed"
									checked={selectedItem.is_receipts_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_receipts_allowed': e.target.checked
									})} />
							</div>
						</div>

						{/* Инвентаризация из своей программы или бота: проведённая списывает недостачу по себестоимости
						и попадает в P&L, поэтому право отдельное от прихода. Без проведения создаётся черновик */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_inventories_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_inventories_allowed"
									checked={selectedItem.is_inventories_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_inventories_allowed': e.target.checked
									})} />
							</div>
						</div>

						{/* Перемещения из своей программы или бота: списывают остаток, а на другой логин ещё и ставят
						долг чужой точке и уведомляют её (по умолчанию внешнее создаётся черновиком) */}
						<div className="d-flex justify-content-between mb-2">
							<div className="fw-500 vertical-center">
								{t('api_transfers_access')}
							</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									name="is_transfers_allowed"
									checked={selectedItem.is_transfers_allowed ? true : false}
									onChange={(e) => setSelectedItem({
										...selectedItem, 'is_transfers_allowed': e.target.checked
									})} />
							</div>
						</div>

						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => toggleModalCreateUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE */}

			{/* MODAL WEBHOOK */}
			<IntegrationKeyWebhook
				show={!!webhookItem}
				item={webhookItem}
				onHide={() => {
					setWebhookItem(null)
					searchWithFilter()
				}}
			/>
			{/* MODAL WEBHOOK */}
		</>
	)
}

export default Index
